import React from 'react';
import LoginForm from '../../components/Member/Login/loginForm';

function Login() {
  return (
    <div className="login-page-wrapper">
      <LoginForm />
    </div>
  );
}

export default Login;
